import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, mergeProps as _mergeProps, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, unref as _unref, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "cart-list" }
const _hoisted_2 = { class: "mr-2" }
const _hoisted_3 = { class: "flex-grow-1 pb-0 cart-item-text" }
const _hoisted_4 = { class: "d-flex cart-item-actions" }
const _hoisted_5 = { class: "align-self-center mr-2" }
const _hoisted_6 = { class: "flex-grow-1 pb-1 pt-0" }
const _hoisted_7 = { class: "align-self-center d-flex flex-column" }

import { ref, computed } from 'vue';
import { nextTick } from 'vue';
import QuantityChip from '@/venit/components/cortona-venit/components/basic/QuantityChip.vue';
import rules from '@/venit/components/cortona-venit/utils/rules';
import { useCortonaViewerStore } from '@/stores/cortonaViewer';
import OrderButton from '../orders/OrderButton.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'Cart',
  setup(__props, { expose: __expose }) {

const showComments = ref<Record<string, boolean>>({});
const menu = ref(false);
const highlight = ref(-1);
const partListValid = ref(true);
const manualPart = ref<any>(null);
const manualPartValid = ref(false);
const r = rules;

const cortonaViewerStore = useCortonaViewerStore();

const cartItems = computed(() => cortonaViewerStore.cartItems);
const count = computed(() => cartItems.value.length);

const update = (item: any) => cortonaViewerStore.updateItem(item);


const add = async (item: any) => {
    try {
        let existing = await cortonaViewerStore.addToCart(item);
        if (existing >= 0) {
            menu.value = true;
            highlight.value = existing;
            nextTick(() => setTimeout(() => (highlight.value = -1), 200));
        }
    } catch {
        // Error already shown as toast by api.js checkResponse
    }
};

const remove = (id: any) => cortonaViewerStore.removeFromCart(id);

const saveManualPart = () => {
    if (!manualPart.value.note) manualPart.value.note = undefined;
    cortonaViewerStore.addToCart(manualPart.value);
    manualPart.value = null;
};

const toggleComment = (itemId: any) => {
    showComments.value[itemId] = !showComments.value[itemId];
};

cortonaViewerStore.loadCart();

__expose({ add });

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_badge = _resolveComponent("v-badge")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_avatar = _resolveComponent("v-avatar")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_list_item_subtitle = _resolveComponent("v-list-item-subtitle")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_textarea = _resolveComponent("v-textarea")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_sheet = _resolveComponent("v-sheet")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_menu = _resolveComponent("v-menu")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createBlock(_component_v_menu, {
    modelValue: menu.value,
    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((menu).value = $event)),
    "close-on-content-click": false,
    location: "bottom end",
    transition: "slide-y-transition"
  }, {
    activator: _withCtx(({ props }) => [
      _withDirectives((_openBlock(), _createBlock(_component_v_btn, _mergeProps({
        icon: "",
        variant: "text"
      }, props, { class: "cart-btn" }), {
        default: _withCtx(() => [
          _createVNode(_component_v_badge, {
            content: count.value,
            "model-value": count.value > 0,
            color: "accent",
            "offset-x": "-5",
            "offset-y": "-5",
            class: "cart-badge"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_icon, null, {
                default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                  _createTextVNode("mdi-cart", -1 /* CACHED */)
                ]))]),
                _: 1 /* STABLE */
              })
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["content", "model-value"])
        ]),
        _: 1 /* STABLE */
      }, 16 /* FULL_PROPS */)), [
        [
          _directive_tooltip,
          _ctx.$t('cart.name'),
          void 0,
          { "bottom-center": true }
        ]
      ])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_v_card, { class: "cart-card" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_list, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_list_item, null, {
                prepend: _withCtx(() => [
                  _createVNode(_component_v_avatar, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_icon, { color: "primary" }, {
                        default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                          _createTextVNode("mdi-cart", -1 /* CACHED */)
                        ]))]),
                        _: 1 /* STABLE */
                      })
                    ]),
                    _: 1 /* STABLE */
                  })
                ]),
                append: _withCtx(() => [
                  _createVNode(_component_v_chip, {
                    label: "",
                    class: "d-flex justify-center mr-2"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t("cart.part-count", count.value)), 1 /* TEXT */)
                    ]),
                    _: 1 /* STABLE */
                  }),
                  _withDirectives((_openBlock(), _createBlock(_component_v_btn, {
                    icon: "",
                    size: "small",
                    variant: "text",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (menu.value = false))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_icon, { size: "small" }, {
                        default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                          _createTextVNode("mdi-arrow-up-drop-circle-outline", -1 /* CACHED */)
                        ]))]),
                        _: 1 /* STABLE */
                      })
                    ]),
                    _: 1 /* STABLE */
                  })), [
                    [
                      _directive_tooltip,
                      _ctx.$t('cart.hide'),
                      void 0,
                      { "bottom-end": true }
                    ]
                  ])
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_v_list_item_title, null, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t("cart.name")), 1 /* TEXT */)
                    ]),
                    _: 1 /* STABLE */
                  })
                ]),
                _: 1 /* STABLE */
              })
            ]),
            _: 1 /* STABLE */
          }),
          _createVNode(_component_v_divider),
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_v_list, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_form, {
                  modelValue: partListValid.value,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((partListValid).value = $event))
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(cartItems.value, (item, index) => {
                      return (_openBlock(), _createBlock(_component_v_list_item, {
                        key: item.partNumber,
                        class: _normalizeClass({ nobg: true, highlight: highlight.value == index })
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_col, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_row, null, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_2, [
                                    _createVNode(QuantityChip, {
                                      modelValue: item.quantity,
                                      "onUpdate:modelValue": ($event: any) => ((item.quantity) = $event),
                                      min: 1,
                                      max: 99,
                                      onInput: ($event: any) => (update(item))
                                    }, null, 8 /* PROPS */, ["modelValue", "onUpdate:modelValue", "onInput"])
                                  ]),
                                  _createElementVNode("div", _hoisted_3, [
                                    _createVNode(_component_v_list_item_title, null, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(item.partName), 1 /* TEXT */)
                                      ]),
                                      _: 2 /* DYNAMIC */
                                    }, 1024 /* DYNAMIC_SLOTS */),
                                    _createVNode(_component_v_list_item_subtitle, null, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(item.partNumber), 1 /* TEXT */)
                                      ]),
                                      _: 2 /* DYNAMIC */
                                    }, 1024 /* DYNAMIC_SLOTS */)
                                  ]),
                                  _createElementVNode("div", _hoisted_4, [
                                    (!item.note)
                                      ? _withDirectives((_openBlock(), _createBlock(_component_v_btn, {
                                          key: 0,
                                          icon: "",
                                          size: "small",
                                          variant: "plain",
                                          onClick: ($event: any) => (toggleComment(item.id))
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_icon, { size: "small" }, {
                                              default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                                                _createTextVNode("mdi-comment-edit-outline", -1 /* CACHED */)
                                              ]))]),
                                              _: 1 /* STABLE */
                                            })
                                          ]),
                                          _: 1 /* STABLE */
                                        }, 8 /* PROPS */, ["onClick"])), [
                                          [
                                            _directive_tooltip,
                                            _ctx.$t('cart.add-comment'),
                                            void 0,
                                            { "bottom-end": true }
                                          ]
                                        ])
                                      : _createCommentVNode("v-if", true),
                                    _withDirectives((_openBlock(), _createBlock(_component_v_btn, {
                                      icon: "",
                                      size: "small",
                                      variant: "plain",
                                      onClick: ($event: any) => (remove(item.id))
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_icon, { size: "small" }, {
                                          default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
                                            _createTextVNode("mdi-close", -1 /* CACHED */)
                                          ]))]),
                                          _: 1 /* STABLE */
                                        })
                                      ]),
                                      _: 1 /* STABLE */
                                    }, 8 /* PROPS */, ["onClick"])), [
                                      [
                                        _directive_tooltip,
                                        _ctx.$t('cart.remove'),
                                        void 0,
                                        { "bottom-end": true }
                                      ]
                                    ])
                                  ])
                                ]),
                                _: 2 /* DYNAMIC */
                              }, 1024 /* DYNAMIC_SLOTS */),
                              (item.note || showComments.value[item.id])
                                ? (_openBlock(), _createBlock(_component_v_row, {
                                    key: 0,
                                    class: "mb-1"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_textarea, {
                                        "model-value": item.note,
                                        "onUpdate:modelValue": v => { item.note = v || null; },
                                        "onClick:clear": ($event: any) => {item.note = null; update(item)},
                                        onBlur: () => { if (!item.note) { item.note = null; } update(item) },
                                        placeholder: _ctx.$t('cart.type-comment'),
                                        class: "text-body-2 mx-2",
                                        rules: [_unref(r).maxLength(200)],
                                        density: "compact",
                                        "hide-details": "auto",
                                        "no-resize": "",
                                        "auto-grow": "",
                                        clearable: "",
                                        "clear-icon": "mdi-backspace-outline",
                                        rows: "1"
                                      }, null, 8 /* PROPS */, ["model-value", "onUpdate:modelValue", "onClick:clear", "onBlur", "placeholder", "rules"])
                                    ]),
                                    _: 2 /* DYNAMIC */
                                  }, 1024 /* DYNAMIC_SLOTS */))
                                : _createCommentVNode("v-if", true)
                            ]),
                            _: 2 /* DYNAMIC */
                          }, 1024 /* DYNAMIC_SLOTS */)
                        ]),
                        _: 2 /* DYNAMIC */
                      }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["class"]))
                    }), 128 /* KEYED_FRAGMENT */))
                  ]),
                  _: 1 /* STABLE */
                }, 8 /* PROPS */, ["modelValue"]),
                _createVNode(_component_v_list_item, { class: "mt-2 px-2" }, {
                  default: _withCtx(() => [
                    (!!manualPart.value)
                      ? (_openBlock(), _createBlock(_component_v_sheet, {
                          key: 0,
                          color: "#f8f8f8",
                          border: "",
                          class: "pa-2",
                          rounded: ""
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_form, {
                              modelValue: manualPartValid.value,
                              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((manualPartValid).value = $event))
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_col, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_row, { class: "d-flex flex-row align-center" }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("div", _hoisted_5, [
                                          _createVNode(QuantityChip, {
                                            modelValue: manualPart.value.quantity,
                                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((manualPart.value.quantity) = $event)),
                                            min: 1,
                                            max: 99
                                          }, null, 8 /* PROPS */, ["modelValue"])
                                        ]),
                                        _createElementVNode("div", _hoisted_6, [
                                          _createVNode(_component_v_text_field, {
                                            modelValue: manualPart.value.partName,
                                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((manualPart.value.partName) = $event)),
                                            rules: [_unref(r).required, _unref(r).maxLength(30)],
                                            placeholder: _ctx.$t('cart.part-name'),
                                            class: "text-body-2",
                                            variant: "filled",
                                            density: "compact",
                                            "hide-details": "auto"
                                          }, null, 8 /* PROPS */, ["modelValue", "rules", "placeholder"]),
                                          _createVNode(_component_v_text_field, {
                                            modelValue: manualPart.value.partNumber,
                                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((manualPart.value.partNumber) = $event)),
                                            rules: [_unref(r).required, _unref(r).maxLength(30)],
                                            placeholder: _ctx.$t('cart.part-number'),
                                            class: "text-body-2",
                                            variant: "filled",
                                            density: "compact",
                                            "hide-details": "auto"
                                          }, null, 8 /* PROPS */, ["modelValue", "rules", "placeholder"])
                                        ]),
                                        _createElementVNode("div", _hoisted_7, [
                                          _withDirectives((_openBlock(), _createBlock(_component_v_btn, {
                                            icon: "",
                                            onClick: saveManualPart,
                                            color: "success",
                                            disabled: !manualPartValid.value,
                                            size: "small"
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_icon, { size: "small" }, {
                                                default: _withCtx(() => [...(_cache[15] || (_cache[15] = [
                                                  _createTextVNode("mdi-check-circle", -1 /* CACHED */)
                                                ]))]),
                                                _: 1 /* STABLE */
                                              })
                                            ]),
                                            _: 1 /* STABLE */
                                          }, 8 /* PROPS */, ["disabled"])), [
                                            [
                                              _directive_tooltip,
                                              _ctx.$t('cart.confirm'),
                                              void 0,
                                              { "bottom-end": true }
                                            ]
                                          ]),
                                          _withDirectives((_openBlock(), _createBlock(_component_v_btn, {
                                            icon: "",
                                            size: "small",
                                            onClick: _cache[5] || (_cache[5] = ($event: any) => (manualPart.value = null)),
                                            class: "my-1"
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_icon, { size: "small" }, {
                                                default: _withCtx(() => [...(_cache[16] || (_cache[16] = [
                                                  _createTextVNode("mdi-close", -1 /* CACHED */)
                                                ]))]),
                                                _: 1 /* STABLE */
                                              })
                                            ]),
                                            _: 1 /* STABLE */
                                          })), [
                                            [
                                              _directive_tooltip,
                                              _ctx.$t('cart.cancel'),
                                              void 0,
                                              { "bottom-end": true }
                                            ]
                                          ])
                                        ])
                                      ]),
                                      _: 1 /* STABLE */
                                    }),
                                    _createVNode(_component_v_row, null, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_textarea, {
                                          modelValue: manualPart.value.note,
                                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((manualPart.value.note) = $event)),
                                          variant: "filled",
                                          placeholder: _ctx.$t('cart.optional-comment'),
                                          class: "text-body-2",
                                          rules: [_unref(r).maxLength(200)],
                                          density: "compact",
                                          "hide-details": "auto",
                                          "no-resize": "",
                                          "auto-grow": "",
                                          clearable: "",
                                          "clear-icon": "mdi-backspace-outline",
                                          rows: "1"
                                        }, null, 8 /* PROPS */, ["modelValue", "placeholder", "rules"])
                                      ]),
                                      _: 1 /* STABLE */
                                    })
                                  ]),
                                  _: 1 /* STABLE */
                                })
                              ]),
                              _: 1 /* STABLE */
                            }, 8 /* PROPS */, ["modelValue"])
                          ]),
                          _: 1 /* STABLE */
                        }))
                      : (_openBlock(), _createBlock(_component_v_btn, {
                          key: 1,
                          variant: "outlined",
                          block: "",
                          size: "large",
                          onClick: _cache[8] || (_cache[8] = ($event: any) => (manualPart.value = { manual: true, quantity: 1, partName: '', partNumber: '', note: '' }))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_icon, { class: "mr-2" }, {
                              default: _withCtx(() => [...(_cache[17] || (_cache[17] = [
                                _createTextVNode("mdi-plus-circle-outline", -1 /* CACHED */)
                              ]))]),
                              _: 1 /* STABLE */
                            }),
                            _createTextVNode(" " + _toDisplayString(_ctx.$t("cart.add-manually")), 1 /* TEXT */)
                          ]),
                          _: 1 /* STABLE */
                        }))
                  ]),
                  _: 1 /* STABLE */
                })
              ]),
              _: 1 /* STABLE */
            })
          ]),
          _createVNode(_component_v_card_actions, null, {
            default: _withCtx(() => [
              _createVNode(OrderButton, {
                class: "pa-0",
                disabled: !count.value || !partListValid.value || !!manualPart.value
              }, null, 8 /* PROPS */, ["disabled"])
            ]),
            _: 1 /* STABLE */
          })
        ]),
        _: 1 /* STABLE */
      })
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["modelValue"]))
}
}

})